<template>
    <ul class="list-group">
        <li v-for="event in calendarFiltered"
            :class="[
              event.conflict ? 'bg-warning' : '',
            ]"
            class="list-group-item d-flex align-items-start">
            <span :class='[
              event.type === "tour" ? "text-secondary" : "",
              event.type === "allotment" ? "text-success" : "",
              event.type === "productTest" ? "text-primary" : "",
              ]'><i class="fa fa-circle"></i></span>
            <div class="ml-2">
                <strong v-if="event.type === 'tour'">
                    {{ event.resource.name }}
                </strong>
                <strong v-if="event.type === 'allotment'">
                    {{ event.resource.title }}
                </strong>
                <strong v-if="event.type === 'productTest'">
                    Test {{ event.resource.tour.name }}
                </strong>
                <small class="text-muted d-block">
                    {{ $t('Start at:') }} {{ dayjs(event.start_at).format('lll') }}
                    <br>
                    {{ $t('End at:') }} {{ dayjs(event.end_at).format('lll') }}
                </small>
            </div>
        </li>
    </ul>
</template>

<script>
import dayjs from "dayjs";

export default {
    props: {
        histories: {
            type: Array,
            default: () => []
        },
        start_at: {
            default: null,
        },
        end_at: {
            default: null,
        },
    },
    computed: {
        dayjs() {
            return dayjs
        },
        calendarFiltered : function ()
        {
            /*
            let start_at = this.start_at ? new Date(this.start_at) : null
            let end_at = this.end_at ? new Date(this.end_at) : null
             */

            return this.histories
                .map((event) => {
                    const start_at = this.start_at ? new Date(this.start_at) : null
                    const end_at = this.end_at ? new Date(this.end_at) : null
                    const event_start_at = event.start_at ? new Date(event.start_at) : null
                    const event_end_at = event.end_at ? new Date(event.end_at) : null

                    const display = [
                        [start_at, event_start_at],
                        [start_at, event_end_at],
                        [end_at, event_start_at],
                        [end_at, event_start_at],
                    ].some((date) => {
                        const diffDays = Math.ceil(Math.abs(date[0] - date[1]) / (1000 * 60 * 60 * 24));
                        return diffDays < 30
                    }) || ! event_end_at;

                    const conflict =
                      start_at < event_start_at && end_at > event_end_at // end during an event
                      || start_at < event_end_at && end_at > event_end_at // start during an event
                      || start_at < event_start_at && start_at > event_end_at // curent date include an event
                      || start_at > event_start_at && end_at < event_end_at // curent date are included in an event

                    return {
                        ...event,
                        display: display,
                        conflict : conflict
                    }
              }).filter((event) => {
                  return event.display
              }).sort((event1, event2) => {
                  if ( + event1.conflict > + event2.conflict) {
                      return -1
                  }

                  if (+ event1.conflict === + event2.conflict) {
                      let start_event1 = event1.start_at ? new Date(event1.start_at) : null
                      let start_event2 = event2.start_at ? new Date(event2.start_at) : null
                      return start_event1 > start_event2 ? 0 : -1
                  }

                  return 0
              })
        }
    },
}
</script>

<style scoped>

</style>
